import styled from 'styled-components';
import { colors } from 'ui/theme';

export const Cell = styled.div<{ columnId: string; rowIndex: number }>`
  grid-column: col-${({ columnId }) => columnId} / span 1;
  padding: 15px ${({ theme }) => theme.spacing.values.plusHalf};
  display: flex;
  flex-direction: column;
  font-family: 'Sofia Pro', system-ui, -apple-system, BlinkMacSystemFont, 'Avenir Next', Avenir,
    'Segoe UI', 'Lucida Grande', 'Helvetica Neue', Helvetica, 'Fira Sans', Roboto, Noto,
    'Droid Sans', Cantarell, Oxygen, Ubuntu, 'Franklin Gothic Medium', 'Century Gothic',
    'Liberation Sans', sans-serif;
  justify-content: center;
  background-color: ${({ rowIndex }) =>
    rowIndex % 2 === 0 && rowIndex !== undefined && colors.backgroundSecondary};
`;
